<template>
    <div  class="all-height">
        <el-main class="all-height">
            <div class="operation-bar">
                <h1>采购审批</h1>
                <div class="operation-bar-right">
                    <div class="input-box">
                        <i class="el-icon-search" @click="query"></i>
                        <input type="text" v-model="orderNo" placeholder="订单编号、制单人"/>
                    </div>
                </div>
            </div>
            <div class="table-box">
                <el-table :data="detailList" height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA', color: 'white'}">
                    <el-table-column type="index" width="50" label="序号" align="center" header-align="center" >
                    </el-table-column>
                    <el-table-column property="orderNo" width="120" label="订单编号" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="vendorName" width="150" label="供应商" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="sapMarkerName" width="100" label="制单人" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="orderDate" width="120" label="订单日期" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="orderNo" width="120" label="订单编号" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column label="行项目号" width="80"  align="center" header-align="center"  :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editOrderDetails(scope.$index, scope.row)">{{scope.row.rowNo}}</el-button>
                        </template>
                    </el-table-column>

                    <el-table-column label="物料编码" width="120" align="center" header-align="center"  :show-overflow-tooltip='true'>
                        <template slot-scope="scope">
                            <span>{{scope.row.sapMtrlCode.substr(-10,10)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="sapMtrlName" width="250" label="物料名称" align="center" header-align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="price" width="100"  label="价格" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="uom" width="50" label="单位" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="qty" width="100" label="数量" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="expectDate" width="100" label="交货日期" align="center" header-align="center"  :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="250" property="vendorRemark" label="沟通备注" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                    <el-table-column property="ownerRemark" label="采购方备注" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                    <el-table-column property="ztttext" label="抬头文本" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.current"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>

            <el-dialog
                    title="修改订单明细"
                    :show-close = "false"
                    :visible.sync="dialogVisible"
                    width="40%">
                <el-form :model="editForm">
                    <el-form-item label="物料编码" :label-width="labelWidth">
                        <el-input v-model="editForm.sapMtrlCode" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="物料名称" :label-width="labelWidth">
                        <el-input v-model="editForm.sapMtrlName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="价格" :label-width="labelWidth" >
                        <el-input v-model="editForm.price" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="交货日期" :label-width="labelWidth" >
                        <el-date-picker
                                v-model="editForm.expectDate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                style="width: 100%"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注" :label-width="labelWidth" >
                        <el-input v-model="editForm.vendorRemark" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button @click="acceptOrderDetailModify">同意提交</el-button>
              </span>
            </el-dialog>
        </el-main>

    </div>

</template>

<script>
    export default {
        name: "purchase-management",
        data() {
            return {
                detailList: [],
                page: {
                    current: 1,
                    pageSize: 15,
                    pageSizes: [15,30,50,100],
                    total: 0
                },
                orderNo: '',
                labelWidth: '80px',
                current: 1,
                editForm: {
                    id: '',
                    sapMtrlCode: '',
                    sapMtrlName: '',
                    price: '',
                    expectDate: '',
                    vendorRemark: '',
                    ordersDetailModifyStatus: '',
                    ordersDetailModifyId: ''
                },
                editForm_bak: {},
                isModify: true,
                dialogVisible: false,
                keywords: ''
            }
        },
        methods: {
            handleSizeChange(val) {
                this.page.pageSize = val;
                this.loadDetailList();
            },

            handleCurrentChange(val) {
                this.page.current = val;
                this.loadDetailList();
            },

            loadDetailList() {
                this.$store.dispatch('order/order/getReviewOrderDetailList', {
                    current: this.page.current,
                    size: this.page.pageSize,
                    orderNo: this.orderNo,
                }).then((res)=> {
                    this.detailList = res.records;
                    this.page.total = res.total;
                })
            },

            query() {
                this.page.current = 1;
                this.loadDetailList();
            },

            editOrderDetails(index, row) {
                this.editForm = row;
                this.editForm_bak = JSON.parse(JSON.stringify(row));
                this.dialogVisible = true;
            },

            acceptOrderDetailModify() {
                this.$store.dispatch('order/order/acceptOrderDetailModify', this.editForm).then((ret)=>{
                    if(ret.code === '200'){
                        this.$message.success(ret.message);
                        this.dialogVisible = false;
                        this.query();
                    }else{
                        this.$message.error(ret.data?ret.data : ret.message);
                    }
                })
            },

            cancel() {
                this.editForm.vendorRemark = this.editForm_bak.vendorRemark;
                this.editForm.price = this.editForm_bak.price;
                this.editForm.expectDate = this.editForm_bak.expectDate;
                this.dialogVisible = false;
            },

        },
        created() {
            this.loadDetailList();
        }
    };
</script>

<style scoped>
    .table-box{
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 35px);
        width: 100%;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
    .el-table .el-button{
        padding: 0;
    }
    .cell i {
        font-size: 25px;
        cursor: pointer;
    }
    .cell i:hover {
        color: #5ED1FD;
    }
    .textArea-box {
        max-height: 300px;
        overflow-y: scroll;
    }
</style>
